
import { defineComponent, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { IStoreType } from '@/store/types'

import 'vue3-video-play/dist/style.css' // 引入css

export default defineComponent({
  setup() {
    const store = useStore<IStoreType>()
    // 获取初始数据
    const articleList = computed(() => {
      return store.state.pageMylifeModule.FriendshipLink
    })

    onMounted(() => {
      if (!articleList.value.length) {
        //   // 调用初始数据接口
        store.dispatch('pageMylifeModule/onArticle', { str: 'friendshipLink' })
      }
    })
    return {
      articleList
    }
  }
})
